<template>
  <div class="d-flex justify-content-between text-decoration padding size-tag">
    <div class="size-info">
      <div class="size-label">
        <label class="hover">{{ `${name}` }}</label>
      </div>
      <div class="size-value">
        <label>{{ `${size}` }}</label>
      </div>
    </div>
    <div class="delete-button">
      <div
        v-if="isFavourite"
        class="hover-delete-icon hover-icon"
        @mousedown="deleteFavouriteSizeOfProduct($event,id)">
        <icon :name="'trash'"/>
      </div>
    </div>


  </div>
</template>

<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:  'Size',
  props: {
    id:          String,
    name:        String,
    size:        String,
    unit:        String,
    isFavourite: Boolean,
  },
  methods: {
    deleteFavouriteSizeOfProduct(event, id) {
      EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
        request: 'deleteFavouriteSizeFromAPI',
        data:    {
          id,
        },
        message: 'Are you sure you want to delete this canvas size from your favorites?',
      });
      event.stopPropagation();
    },
  },

};
</script>

<style scoped  lang="scss">
.size-tag{
  border-bottom: solid thin #ededed;
  .size-info{
    flex: 1 1 auto;
    display: flex;
    justify-content: space-between;
    .size-label{
      word-break: break-word;
    }
    .size-value{
      display: flex;
      flex: 0 0 auto;
      margin-left: 5px;
    }
  }
  .delete-button{
    flex: 0 0 24px;
    display: flex;
    justify-content: end;
  }
  .hover:hover{
    cursor: pointer;
    color: #3bb0fa !important;
  }
  .hover-delete-icon:hover{
    border-radius: 2px;
  }
}

</style>
